import { cn } from "@/lib/utils";

interface CategoryTabProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

/**
 * The active tab's underline. Its own bar rather than a bottom border, because
 * the button is rounded and a border follows those corners into a curve.
 */
export const TabUnderline = ({ className }: { className?: string }) => (
  <span
    className={cn(
      "absolute inset-x-2 bottom-0 h-0.5 bg-primary-active",
      className,
    )}
  />
);

/** One category in a row of filter tabs: an underline on desktop, a filled pill on touch. */
export const CategoryTab = ({ label, isActive, onClick }: CategoryTabProps) => (
  <button
    className={cn(
      "text-sm font-medium px-4 touch-device:px-2 py-1.5 flex justify-start items-center gap-x-1 select-none whitespace-nowrap relative text-left rounded",
      isActive
        ? "text-foreground max-touch-device:bg-surface-raised"
        : "text-foreground-faint hover:text-foreground-body hover:bg-surface-raised",
    )}
    onClick={onClick}
  >
    {label}
    {/* Primary blue marks the category the grid below shows. Hidden on touch,
        where the active tab is a filled pill instead. */}
    {isActive && <TabUnderline className="max-touch-device:hidden" />}
  </button>
);
